import GradientContainer from "@app/components/gradient/gradient-container";
import Image from "next/image";

const EquippedSectionBottomContent = () => {
  return (
    <div className="flex flex-col-reverse md:grid md:grid-cols-12 w-full md:gap-x-4 lg:gap-x-16">
      <div className="mt-8 md:mt-0 md:col-span-6 flex flex-row justify-end items-center">
        <div className="md:w-[560px] flex flex-col items-start space-y-4">
          <span className="mobile-h3 md:h4 lg:h3 text-text-color-high-em">
            Strategic Advantages
          </span>
          <GradientContainer>
            <div className="h-2 w-40" />
          </GradientContainer>
          <span className="text-body-lg text-text-color-mid-em">
            We’re continually looking for the most dependable providers in the
            industry. Be at an industry advantage through our “anywhere
            accessible” platform.
          </span>
        </div>
      </div>
      <div className="md:col-span-6">
        <div className="flex justify-center md:justify-start items-center h-full">
          <Image
            src="/images/haulers/equipped-02.png"
            alt="Equipped"
            width={550}
            height={519}
          />
        </div>
      </div>
    </div>
  );
};

export default EquippedSectionBottomContent;
